import { defaultTheme } from 'gd-design-library';

export const inputfile = {
  ...defaultTheme.inputfile,
  input: {
    ...defaultTheme.inputfile.input,
    display: 'none'
  }
};
